var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_24856_81380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.61836 12.7503L8.00169 11.3336L10.385 12.7669L9.73503 10.0836L11.835 8.25026L9.06836 8.01693L8.00169 5.48359L6.93503 8.01693L4.16836 8.23359L6.26836 10.0503L5.61836 12.7503ZM3.26836 16.0336L4.51836 10.6336L0.318359 7.00026L5.85169 6.53359L8.00169 1.43359L10.1517 6.53359L15.685 7.00026L11.485 10.6336L12.7517 16.0336L8.00169 13.1503L3.26836 16.0336Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24856_81380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlStarIcon);
export default __webpack_public_path__ + "static/media/bl-star-icon.69ebf1527deb87a6124135c53b2ed97b.svg";
export { ForwardRef as ReactComponent };